// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"b461f835","247":"b94176f1","373":"9e48ed44","617":"8dfca756","856":"04c17a69","858":"0f2e0b24","991":"478e27a4"}[chunkId] + ".chunk.js";
};